<template>
  <van-tabbar v-model="active" route>
    <van-tabbar-item name="index" icon="home-o" to="/list">
      <template #icon="{ active }">
        <img :src="active ? require('@/assets/images2026/home-icon-a.png') : require('@/assets/images2026/home-icon.png')" width="40" height="24" alt="首页"/>
      </template>
      <span :class="{ 'active-text': active === 'index' }">首页</span>
    </van-tabbar-item>
    <van-tabbar-item name="claimList" icon="document-o" to="/claimList">
      <template #icon="{ active }">
        <img :src="active ? require('@/assets/images2026/remark-icon-a.png') : require('@/assets/images2026/remark-icon.png')" width="40" height="24" alt="认领记录"/>
      </template>
      <span :class="{ 'active-text': active === 'claimList' }">认领记录</span>
    </van-tabbar-item>
    <van-tabbar-item name="timecapsule" icon="clock-o" to="/timecapsule">
      <template #icon="{ active }">
        <img :src="active ? require('@/assets/images2026/time-icon-a.png') : require('@/assets/images2026/time-icon.png')" width="40" height="24" alt="时光胶囊"/>
      </template>
      <span :class="{ 'active-text': active === 'look' }">时光胶囊</span>
    </van-tabbar-item>
    <van-tabbar-item name="dynamic" icon="fire-o" to="/dynamic">
      <template #icon="{ active }">
        <img :src="active ? require('@/assets/images2026/dynamic-icon-a.png') : require('@/assets/images2026/dynamic-icon.png')" width="40" height="24" alt="最新动态"/>
      </template>
      <span :class="{ 'active-text': active === 'dynamic' }">最新动态</span>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  data() {
    return {
      active: 'list'
    }
  },
  watch: {
    // 监听路由变化，更新激活的标签
    $route(to) {
      if (to.path === '/list') {
        this.active = 'list'
      } else if (to.path === '/claimList') {
        this.active = 'claimList'
      } else if (to.path === '/look') {
        this.active = 'look'
      } else if (to.path === '/dynamic') {
        this.active = 'dynamic'
      } else if (to.path === '/' || to.path === '/index') {
        this.active = 'index'
      }
    }
  },
  mounted() {
    // 初始化时根据当前路由设置激活的标签
    if (this.$route.path === '/' || this.$route.path === '/index') {
      this.active = 'index'
    } else if (this.$route.path === '/claimList') {
      this.active = 'claimList'
    } else if (this.$route.path === '/timecapsule') {
      this.active = 'timecapsule'
    } else if (this.$route.path === '/list') {
      this.active = 'list'
    } else if (this.$route.path === '/dynamic') {
      this.active = 'dynamic'
    }
  }
}
</script>

<style scoped>
.van-tabbar {
  background-color: #FFFBE7;
  border-top: 1px solid #EEEEEE;
}

.van-tabbar-item {
  font-size: 18px;
}

.van-tabbar-item__text {
  color: #717171;
}
.van-tabbar-item--active{
    background-color: #FFFBE7 !important;
}

.van-tabbar-item__icon img{
    width: auto !important;
}
.van-tabbar-item--active{
    color: #EB0139 !important;
}
.active-text {
  color: #EB0139;
}
</style>